export default __webpack_public_path__ + "assets/img/main-nav-bg-6f46c149fb7a99a8d19be7350fbcd07e.webp";